import * as React from 'react';
import { Box, Card, Divider, styled, Typography } from '@mui/material';
import { SettingDisplay } from 'lib/SettingDisplay';
import { ImageFormField } from 'lib/form/fields/ImageFormField';
import { MuiForm } from 'lib/Form';

const PREFIX = 'BartabSettings';

const classes = {
    displayClassName: `${PREFIX}-displayClassName`,
    titleWrapper: `${PREFIX}-titleWrapper`
};

const StyledCard = styled(Card)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    [`& .${classes.titleWrapper}`]: {
        marginLeft: theme.spacing(1),
        minHeight: theme.spacing(5.25)
    },
    [`& .${classes.displayClassName}`]: {
        padding: theme.spacing(2)
    }
}));

type IProps = {
    tenantId: string;
};

export const BartabSettings = ({ tenantId }: IProps) => {
    const handleSubmit = React.useCallback(() => {}, []);

    return (
        <StyledCard>
            <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                padding={1}
                justifyContent="space-between"
            >
                <Box display="flex" flexDirection="row" alignItems="center" className={classes.titleWrapper}>
                    <Typography variant="h6">Bartab</Typography>
                </Box>
            </Box>
            <Divider />
            <Box className={classes.displayClassName}>
                <MuiForm
                    onSubmit={handleSubmit}
                    initialValues={{
                        openTabImage: `${process.env.MEDIA_SERVICE_URL}/tenants/${tenantId}/app_assets/open_tab`,
                        joinTabImage: `${process.env.MEDIA_SERVICE_URL}/tenants/${tenantId}/app_assets/join_tab`
                    }}
                >
                    <Box display="flex" flexDirection="column">
                        <SettingDisplay
                            label="Open Tab Image"
                            description="600px by 260px PNG or JPEG"
                            buildtimeAndroid
                            buildtimeIOS
                        >
                            <ImageFormField
                                name="openTabImage"
                                aspect={600 / 260}
                                fileName="open_tab"
                                uploadFolder="app_assets"
                                unremovable
                                downloadable
                            />
                        </SettingDisplay>
                        <SettingDisplay
                            label="Join Tab Image"
                            description="600px by 260px PNG or JPEG"
                            buildtimeAndroid
                            buildtimeIOS
                        >
                            <ImageFormField
                                name="joinTabImage"
                                aspect={600 / 260}
                                fileName="join_tab"
                                uploadFolder="app_assets"
                                unremovable
                                downloadable
                            />
                        </SettingDisplay>
                    </Box>
                </MuiForm>
            </Box>
        </StyledCard>
    );
};
